module.exports = __webpack_public_path__ + "static/media/50_A.0e38b142.png";